export default "__VITE_ASSET__f087acb8__"